<app-head titolo="I nostri insegnanti"></app-head>

<body>
  <p>Nel corso del tempo la squadra di insegnanti di 2+2=0 è cresciuta sempre di più, e così sono cresciute la qualità del nostro insegnamento e le ore di esperienza maturate.</p>
  <p>Di seguito abbiamo il piacere di presentarvi alcuni dei nostri insegnanti, i quali si sono gentilmente messi a disposizione</p>

  <app-teacher></app-teacher>
</body>
